module.exports = __webpack_public_path__ + "static/media/01.031.5f4c720c.webp";